import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { ComponentModel} from '@app/common/models/component.model';
import * as _ from 'lodash';
import { AttachmentTypeModel } from '@app/common/models/attachment-type.model';
import { AttachmentTypePipe } from '@app/common/pipes/attachment-type.pipe';
import * as GMTCK from 'gmt-ckeditor/dist';
import { DialogService } from '@app/common/services/dialog.service';

@Component({
  selector: 'component-edit',
  templateUrl: './component-edit.component.html',
  styleUrls: ['./component-edit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ComponentEditComponent implements OnInit {

  component: ComponentModel;
  attachmentTypes: AttachmentTypeModel[];
  attachmentType: AttachmentTypeModel;
  canEdit;
  canManipulate;
  editor;

  constructor(
    private dialogConfig: DialogConfig,
    public dialogComponent: DialogRef,
    public attachmentTypePipe: AttachmentTypePipe,
    private dialogService: DialogService,
  ) {
    this.onUpdate = this.onUpdate.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  async ngOnInit() {
    this.component = (<DialogConfigData>this.dialogConfig.data).component;
    this.canEdit = (<DialogConfigData>this.dialogConfig.data).canEdit;
    this.canManipulate = (<DialogConfigData>this.dialogConfig.data).canManipulate;
    const isCase = (<DialogConfigData>this.dialogConfig.data).isCase;
    this.attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory('component'))
      .filter(a => !isCase ? !['CONTRACT_EXTERNAL', 'COVERING_LETTER_EXTERNAL'].includes(a.id) : true
    );
    this.attachmentType = this.component.attachmentType ? AttachmentTypeModel.createById(this.component.attachmentType) : undefined;
    await this.prepareEditor();
  }

  isValid() {
    return this.attachmentType;
  }

  onUpdate() {
    this.component.note = this.editor.getData();
    this.component.attachmentType = this.attachmentType ? this.attachmentType.id : undefined;
    this.dialogComponent.close(this.component);
  }

  onCancel() {
    this.dialogComponent.close(false);
  }

  private async prepareEditor() {
    if (this.component.note === undefined) {
      this.component.note = '';
    }
    this.editor = await GMTCK.ClassicEditor.create(document.querySelector('#editor'));
    this.editor.setData(this.component.note);
  }
}
